import { useQuery } from '@tanstack/react-query'
import { useCompanies } from 'contexts/CompaniesContext'
import { UniversalAuctionDetail } from 'models/universalData'
import { currentQueryService } from 'utils/api/queries'
import { extractAuctionVehicleListViewModel } from 'utils/helpers/extractViewModels'

const DEFAULT_LIMIT = 1500

type AuctionVehiclesTimeline = 'future' | 'past'

const useGetAuctionVehicles = (auctionNo: string, timeline: AuctionVehiclesTimeline) => {
  const { filteringCompaniesIds } = useCompanies()
  const query = useQuery<Array<UniversalAuctionDetail>, Error>({
    queryKey: ['useGetAuctionVehicles', timeline, auctionNo, filteringCompaniesIds],
    queryFn: async () => {
      if (!auctionNo || filteringCompaniesIds.length === 0) {
        return []
      }

      const response =
        timeline === 'future'
          ? await currentQueryService.getVehicleListFull(auctionNo, filteringCompaniesIds, {
              offset: 0,
              limit: DEFAULT_LIMIT,
            })
          : await currentQueryService.getVehicleListLight(auctionNo, filteringCompaniesIds, {
              offset: 0,
              limit: DEFAULT_LIMIT,
            })
      return extractAuctionVehicleListViewModel(response.items)
    },
    enabled: Boolean(auctionNo),
    retry: false,
  })

  const data = query.data ?? []

  return {
    data,
    isLoading: query.isLoading,
    error: query.error,
  }
}

export { useGetAuctionVehicles }
export type { AuctionVehiclesTimeline }
